import { useCallback } from 'react';

import { GuideName } from '@app/api/guides';

import { useVisitGuides } from './react-native/use-visit-guides';
import { useApi } from './use-api';

export const useGuide = <T extends EntityBase>(
  name: GuideName,
  additional?: Record<string, string>,
  setLoading?: (loading: boolean) => void
) => {
  const api = useApi();
  const { getGuide } = useVisitGuides();

  return useCallback(async () => {
    const cachedGuide = getGuide(name, additional);
    if (cachedGuide) {
      return Promise.resolve(
        cachedGuide.sort((a, b) => a.name.localeCompare(b.name))
      );
    }
    setLoading?.(true);
    const { data, code } = await api.guides.get({ name, ...additional }); 

    setLoading?.(false);
    if (code === 200) {
      return data.sort((a, b) => a.name.localeCompare(b.name));
    } else {
      return [];
    }
        
  }, [getGuide, name, additional, setLoading]);
};
